import Flex from 'shared/ui/Flex'
import { InlineSkeleton, Skeleton } from 'shared/ui/Skeleton'

const TemplateItemSkeleton = () => {
  return (
    <Flex direction="column" alignItems="center" rowGap={8}>
      <Skeleton height={164} width="100%" radius={8} />
      <InlineSkeleton height={14} width={80} />
    </Flex>
  )
}

export default TemplateItemSkeleton
